// @flow
import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import type Moment from "moment";
import SelecaoDeflator from "./SelecaoDeflator";
import SelecaoValorBaseDeflator from "./SelecaoValorBaseDeflacao";
import SelecaoDataBaseDeflator from "./SelecaoDataBaseDeflacao";
import {
  type State,
  i18n,
  getPeriodoUnicoSelecionado,
  getValorBaseDeflatorOutroSelecionado,
  getValorBaseDeflatorSelecionado,
  getDataBaseDeflatorSelecionado,
  getDataBaseDeflatorEspecificaSelecionada,
} from "../../../../state";
import {
  type Id,
  ID_PERIODO_ANALISE_HORIZONTAL,
  ID_VALOR_BASE_DEFLATOR_OUTRO,
  ID_DATA_BASE_DEFLATOR_DATA_ESPECIFICA,
} from "../../../../model";

type Props = {
  periodoUnicoSelecionado: ?Id,
  exibir: boolean,
};

const exibirSelecaoDeflacao: (state: State) => boolean = (state: State) =>
  getPeriodoUnicoSelecionado(state) !== ID_PERIODO_ANALISE_HORIZONTAL;

function SelecaoDeflacao({ periodoUnicoSelecionado, exibir }: Props) {
  if (!exibir) {
    return null;
  }

  return (
    <div className="ConfiguracaoMedida">
      <div className="ConfiguracaoMedida--flex">
        <SelecaoDeflator />
      </div>

      <div className="ConfiguracaoMedida--flex-spaced">
        <SelecaoValorBaseDeflator />
        <SelecaoDataBaseDeflator />
      </div>
    </div>
  );
}

export const criarFuncaoValidacaoSelecaoDeflacao = (state: State) => () => {
  if (!exibirSelecaoDeflacao(state)) {
    return null;
  }

  const { translate } = i18n(state);

  const valorBaseDeflatorSelecionado: ?Id = getValorBaseDeflatorSelecionado(
    state
  );
  const valorBaseDeflatorOutro: ?number = getValorBaseDeflatorOutroSelecionado(
    state
  );
  const dataBaseDeflatorSelecionada: ?Id = getDataBaseDeflatorSelecionado(
    state
  );
  const dataEspecificaSelecionada: ?Moment = getDataBaseDeflatorEspecificaSelecionada(
    state
  );

  if (valorBaseDeflatorSelecionado === ID_VALOR_BASE_DEFLATOR_OUTRO) {
    if (typeof valorBaseDeflatorOutro !== "number") {
      return {
        selecaoValorBaseDeflator: translate(
          "configuracaoRelatorio.valorBaseDeflatorInvalido"
        ),
      };
    }
  }

  if (dataBaseDeflatorSelecionada === ID_DATA_BASE_DEFLATOR_DATA_ESPECIFICA) {
    if (!moment.isMoment(dataEspecificaSelecionada)) {
      return {
        selecaoDataEspecifica: translate(
          "configuracaoRelatorio.erroDataEspecificaInvalida"
        ),
      };
    }
  }

  return null;
};

export default connect(
  state => ({
    periodoUnicoSelecionado: getPeriodoUnicoSelecionado(state),
    exibir: exibirSelecaoDeflacao(state),
  }),
  {}
)(SelecaoDeflacao);
